import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import type { GridProps } from '@mui/material/Grid';

const StyledGridContainer = styled(Grid)<GridProps>(() => ({
  flex: 1,
  position: 'relative',
  paddingLeft: '24px',
  paddingRight: '24px',
  paddingBottom: '24px',
  boxSizing: 'border-box',
}));

export default StyledGridContainer;
